import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import pt from './locales/pt/translation.json'
import fr from './locales/fr/translation.json'
import en from './locales/en/translation.json'
import es from './locales/es/translation.json'

const resources = {
  pt: {
    translation: pt
  },
  fr: {
    translation: fr
  },
  en: {
    translation: en
  },
  es: {
    translation: es
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already does escaping
      formatSeparator: ',',
      format: function(value, format) {
        if (format === 'uppercase') return value.toUpperCase()
        if (format === 'lowercase') return value.toLowerCase()
        return value
      }
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  })

export default i18n




